const SIX_TEEN = 16;
const TWO = 2;

const b64DecodeUnicode = (str: string): string => {
    return decodeURIComponent(
        window.atob(str).replace(/(.)/g, (m, p) => {
            let code = p.charCodeAt(0).toString(SIX_TEEN).toUpperCase();
            if (code.length < TWO) {
                code = `0${code}`;
            }
            return `%${code}`;
        }),
    );
};

/**
 * @description
 * This function decodes a base64Url encoded string.
 *
 * @param {string} str - The base64Url encoded string to decode.
 * @returns {string} The decoded string.

 * @example
 * const decodedString = base64UrlDecode('SGVsbG8gd29ybGQ=');
 * console.log(decodedString); // Output: 'Hello world'
 */
export const base64UrlDecode = (str: string): string => {
    const output = str?.replace(/-/g, '+').replace(/_/g, '/');

    try {
        return b64DecodeUnicode(output);
    } catch {
        return window.atob(output);
    }
};
